import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { otpLogin } from 'redux/auth/AuthActions';
import { fetchUserPermissions } from 'redux/manageUser/ManageUserActions';
import { fetchContexts, fetchUser } from 'redux/contexts/ContextsActions';
import OTPLogin from './OTPLogin';

const mapStateToProps = state =>({
  userLogged: state.authentication.logged,
  loggingIn: state.authentication.loggingIn,
  selectedOrg: state.contexts.selectedOrg,
  isFetchingContexts: state.contexts.fetchingContexts,
  user: state.contexts.user,
  isFetchingPermissions: state.manageUser.isFetchingPermissions,
  userPermissions: state.manageUser.userPermissions
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    { 
      otpLogin, 
      fetchUserPermissions, 
      fetchContexts, 
      fetchUser
    },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(OTPLogin);



// WEBPACK FOOTER //
// ./src/components/otpLogin/OTPLoginConnector.js